import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumb from "./Breadcrumb";
import { BreadcrumbProvider } from "@/shared/contexts/BreadcrumbContext";
import { ToastProvider } from "@/shared/contexts/ToastContext";

export default function Layout() {
  return (
    <BreadcrumbProvider>
      <ToastProvider>
        <div className="min-h-screen flex flex-col bg-white">
          <Header />
          <main className="flex-1 w-full pb-16">
            <Breadcrumb />
            <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="p-2 sm:p-4 lg:p-6 space-y-6 h-fit bg-white border border-gray-200 rounded-lg shadow-sm">
                <Outlet />
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </ToastProvider>
    </BreadcrumbProvider>
  );
}
